import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { formatMoney, langOf, resources } from '@fos/i18n';

void i18next.use(initReactI18next).init({
  resources,
  lng: langOf(navigator.language),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
  showSupportNotice: false,
});

/** The ACCOUNT language wins over the browser once /v1/me is known (ch. 24). */
export function useAccountLanguage(locale: string | undefined) {
  if (!locale) return;
  const lang = langOf(locale);
  if (i18next.language !== lang) void i18next.changeLanguage(lang);
  document.documentElement.lang = lang;
}

export default i18next;

/**
 * Name of a platform: the label of one added by name, the translation of a main one; without the label an added
 * one shows its key without the prefix ("x_hub_spot" → "hub spot").
 */
export function platformName(platform: string, label?: string | null): string {
  if (label) return label;
  return i18next.t(`platform.${platform}`, { defaultValue: platform.startsWith('x_') ? platform.slice(2).replace(/_/g, ' ') : platform });
}

/** Params shown to people: platform codes become their names ("ga4" → "Google Analytics 4", A9). */
export function humanParams(params: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = typeof params.platform === 'string' ? { ...params, platform: platformName(params.platform) } : { ...params };
  // an amount in minor units with its currency becomes {{amount}} (03/11/2026)
  if (typeof params.amount_minor === 'number' && typeof params.currency === 'string') out.amount = formatMoney(params.amount_minor, params.currency, i18next.language === 'en' ? 'en-GB' : 'it-IT');
  return out;
}
